module.exports = __webpack_public_path__ + "img/isjilus.bf72885e.svg";